import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
// import { DividerOr } from '@/components/ui/divider-or';
// import { GoogleButton } from '@/components/ui/google-button';
import { Input } from '@/components/ui/input';
import { AuthShell } from './auth-shell';

// Phase 1 will replace this with sessions read from an API/storage adapter.
const savedAccounts = [
  {
    id: 'jane',
    name: 'Jane Smith',
    emailMasked: 'janexxxxx@xxxxx.com',
    avatarUrl: 'https://api.dicebear.com/7.x/initials/svg?seed=Jane+Smith&backgroundColor=cbd5e1',
  },
];

export function ChooseAccountPage() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  return (
    <AuthShell>
      <div className="space-y-6">
        <h1 className="text-center text-xl font-semibold leading-snug text-gray-900">
          India&rsquo;s #1 Platform for Legal &amp; Business Documentation
        </h1>

        <div className="space-y-3">
          <div className="text-center text-sm text-gray-600">Choose your account</div>
          {savedAccounts.map((acc) => (
            <button
              key={acc.id}
              type="button"
              onClick={() => navigate(`/otp?email=${encodeURIComponent(acc.emailMasked)}`)}
              className="flex w-full items-center justify-between rounded-md border border-gray-200 bg-white p-3 text-left hover:bg-gray-50"
            >
              <span className="flex items-center gap-3">
                <img src={acc.avatarUrl} alt="" className="h-10 w-10 rounded-full" />
                <span>
                  <span className="block text-sm font-medium text-gray-900">{acc.name}</span>
                  <span className="block text-xs text-gray-500">{acc.emailMasked}</span>
                </span>
              </span>
              <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden className="text-gray-400">
                <path fill="currentColor" d="M8.59 16.59L13.17 12L8.59 7.41L10 6l6 6l-6 6z" />
              </svg>
            </button>
          ))}
        </div>

        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            if (!email) return;
            navigate(`/otp?email=${encodeURIComponent(email)}`);
          }}
        >
          <div className="text-center text-sm text-gray-600">Log in or Sign up</div>
          <Input
            type="email"
            inputMode="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" block>
            Send OTP
          </Button>
          {/* <DividerOr /> */}
          {/* <GoogleButton /> */}
        </form>
      </div>
    </AuthShell>
  );
}
